// extracted by mini-css-extract-plugin
export var container = "central-header-module--container--0nC0R";
export var header = "central-header-module--header--S1TTX";
export var subheader = "central-header-module--subheader--HGvyn";